import React, { useEffect, useState } from "react";
import { customFetcher, deleteFetch, uploadFetch, useFetch } from "../../hooks/useFetch";
import { IService } from "../../interfaces/IService";
import {
    Alert,
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    IconButton,
    LinearProgress,
    MenuItem,
    TextField,
    Typography,
} from "@mui/material";
import { DataGrid, GridColDef, GridRenderCellParams, deDE } from "@mui/x-data-grid";
import { CustomSnackbar } from "../../components/core/Snackbar";
import { IFeedback } from "../../interfaces/IFeedback";
import { IProject } from "../../interfaces/IProject";
import { IProjectState } from "../../interfaces/IProjectState";
import { ICustomer } from "../../interfaces/ICustomer";
import { getEmptyCustomer } from "../../components/customer/CustomerEdit";
import { ProjectEdit } from "../../components/project/ProjectEdit";
import { IInsurance } from "../../interfaces/IInsurance";
import { IOfferType } from "../../interfaces/IOfferType";
import { IOfferState } from "../../interfaces/IOfferState";
import { IGender } from "../../interfaces/IGender";
import { ITitle } from "../../interfaces/ITitle";
import { CustomeTextField } from "../../components/core/CustomeTextField";
import { ITemplate } from "../../interfaces/ITemplate";
import { IPropertyManagment } from "../../interfaces/IPropertyManagement";
import { IAddressType } from "../../interfaces/IAddress";
import { IProfile } from "../../interfaces/IUser";
import { Delete } from "@mui/icons-material";
import { IBillState } from "../../interfaces/IBillState";
import { IProjectParticipant } from "../../interfaces/IProjectParticipant";
import { IMIMEType } from "../../interfaces/IMIMEType";
import { IMaterial } from "../../interfaces/IMaterial";
import { IMaterialCategory } from "../../interfaces/IMaterialCategory";
import { IMaterialSubcategory } from "../../interfaces/IMaterialSubcategory";
import { useGetSystemMail } from "../../hooks/data/data_systemmail";
import { useGetMaterialDocument } from "../../hooks/data/data_material";
import { useGetContractState, useGetContractType } from "../../hooks/data/data_contract";
import {
    useGetProjectId,
    useGetProjectSmall,
    useGetProjectState,
    useUpdateProject,
} from "../../hooks/data/data_project";
import { useGetReasonCancellation } from "../../hooks/data/data_generic";
import { useCreateAutomationTrigger, useGetAutomation } from "../../hooks/data/data_automation";
import { IAutomationTrigger } from "../../interfaces/IAutomationTrigger";
import { IAutomationMailWorkerEdit } from "../../interfaces/IAutomationMail";
import { AutomationMailWorkerEditDialog } from "../../components/automation/AutomationMailWorkerEdit/AutomationMailWorkerEditDialog";
import { useUpdateOfferPositions } from "../../hooks/data/data_offer";
import { IOffer } from "../../interfaces/IOffer";
import { IOfferPosition } from "../../interfaces/IOfferPosition";
import { useGetInvoiceStates, useGetInvoiceTypes } from "../../hooks/data/data_invoice";
import { useNavigate, useParams } from "react-router-dom";
import { useGetUnits } from "../../hooks/data/data_unit";
import { useGetServiceCategories, useGetServices } from "../../hooks/data/data_service";
import { useGetPartners } from "../../hooks/data/data_partner";

const handleProjectState = (id: number, projectStateArray: IProjectState[] = []) => {
    let testObject = projectStateArray.find((x) => x.id === id);

    if (testObject === undefined) {
        return <Chip label="Fehler" variant="outlined" />;
    } else {
        if (testObject.id === 1) {
            return <Chip variant="outlined" label={testObject.projectState} />;
        } else if (testObject.id === 2 || testObject.id === 3) {
            return <Chip label={testObject.projectState} variant="outlined" color="warning" />;
        } else if (testObject.id === 4 || testObject.id === 5) {
            return <Chip label={testObject.projectState} variant="outlined" color="success" />;
        } else if (testObject.id === 6 || testObject.id === 7) {
            return <Chip label={testObject.projectState} color="success" />;
        } else if (testObject.id === 6 || testObject.id === 7) {
            return <Chip label={testObject.projectState} color="success" />;
        } else if (testObject.id === 9) {
            return <Chip label={testObject.projectState} variant="outlined" color="error" />;
        } else if (testObject.id === 8 || testObject.id === 10) {
            return <Chip label={testObject.projectState} variant="outlined" color="info" />;
        } else if (testObject.id === 11) {
            return <Chip label={testObject.projectState} color="success" />;
        } else if (testObject.id === 11 || testObject.id === 12) {
            return <Chip label={testObject.projectState} color="error" />;
        } else {
            return <Chip label="Fehler" variant="outlined" />;
        }
    }
};
const getEmptyProject = (currentCustomer: ICustomer) => {
    return {
        id: -1,
        title: "",
        ProjectState: 1,
        ConstructionSite: null,
        DeliveryAddress: null,
        project_start: null,
        MainCustomer: null,
        Participant: [],
        Worker: [],
        Worker_Old: [],
        Offers: [],
        Documents: [],
        NoteArray: [],
        date_appointment: null,
        ReasonCancellation: null,
        id_b_appointment: null,
        date_b_appointment: null,
        date_construction_appointment: null,
        id_construction_appointment: null,
        date_acceptance: null,
        date_inquiry: null,
    } as IProject;
};

export const ProjectOverview: React.FC = () => {
    const params = useParams();
    const navigate = useNavigate();

    const { getProjectById, isPendingProjectById } = useGetProjectId();
    const { automationArary, isLoadingAutomationArray } = useGetAutomation();
    const { triggerAutomation, isPendingTriggerAutomation } = useCreateAutomationTrigger();
    const { updateProject, isPendingUpdateProject } = useUpdateProject();
    const { updateOfferPositions, isPendingUpdateOfferPositions } = useUpdateOfferPositions();
    const [automationMailWorkerEditArray, setAutomationMailWorkerEditArray] = useState<IAutomationMailWorkerEdit[]>([]);
    const isPending = isPendingUpdateOfferPositions || isPendingUpdateProject || isPendingTriggerAutomation;
    const [filteredState, setFilteredState] = useState(0);
    const [mimeTypeArray, setMimeTypeArray, statusCodeMimeType] = useFetch<IMIMEType[]>("/document/mimetype/");
    //
    const { projectSmallArray, isLoadingProjectSmallArray, refetchProjectSmall } = useGetProjectSmall();
    //const [projectArray, setProjectArray, statusCodeProject] = useFetch<IProject[]>("/project/small/");
    //
    const { projectStateArray, isLoadingProjectStateArray, refetchProjectState } = useGetProjectState();
    //const [projectStateArray, setProjectStateArray, statusCodeProjectState] =
    //    useFetch<IProjectState[]>("/project/state");
    const [addressTypeArray, setAddressTypeArray, statusCodeAddressType] = useFetch<IAddressType[]>("/address/types/");
    const [genderData, setGenderData, statusCodeGender] = useFetch<IGender[]>("/customer/gender/");
    const [titleData, setTitleData, statusCodeAcademicTitle] = useFetch<ITitle[]>("/customer/academic-title/");
    const [customerArray, setCustomerArray, statusCodeCustomer] = useFetch<ICustomer[]>("/customer/");
    const [userArray, setUserArray, statusCodeUser] = useFetch<IProfile[]>("/user/");
    const [insuranceArray, setInsuranceCodeData, statusCodeInsurance] = useFetch<IInsurance[]>("/insurance/");
    const [propertyManagementArray, setPropertyManagementArray, statusCodePropertyManagement] =
        useFetch<IPropertyManagment[]>("/property_management/");

    const { isLoadingPartnerArray, partnerArray } = useGetPartners();
    //const [partnerArray, setPartnerArray, statusCodePartner] = useFetch<IPartner[]>("/partner");

    const { invoiceStates, isLoadingInvoiceStates, refetchInvoiceStates } = useGetInvoiceStates();
    const { invoiceTypes, isLoadingInvoiceTypes, refetchInvoiceTypes } = useGetInvoiceTypes();

    const [billStateArray, setBillStateArray, statusCodeBillStateArray] = useFetch<IBillState[]>("/bill/state");

    const { units, isLoadingUnits, refetchUnits } = useGetUnits();

    const { serviceArray, isLoadingServices } = useGetServices();
    const { serviceCategoryArray, isLoadingServiceCategories } = useGetServiceCategories();
    //const [serviceArray, setServiceArray, statusCodeService] = useFetch<IService[]>("/service/");
    const [templateArray, setTemplateArray, statusCodeTemplate] = useFetch<ITemplate[]>("/template/");
    const [materialArray, setMaterialArray, statusCodeMaterial] = useFetch<IMaterial[]>("/material/");
    const [materialCategoryArray, setMaterialCategoryArray, statusCodeMaterialCategory] =
        useFetch<IMaterialCategory[]>("/material/category/");
    const [materialSubcategoryArray, setMaterialSubcategoryArray, statusCodeMaterialSubcategory] =
        useFetch<IMaterialSubcategory[]>("/material/subcategory/");
    const [offerTypeArray, setOfferTypeArray, statusCodeOfferType] = useFetch<IOfferType[]>("/offer/type");
    const [offerStateArray, setOfferStateArray, statusCodeOfferState] = useFetch<IOfferState[]>("/offer/state");
    const { systemMailArray, isLoadingSystemMailArray, refetchSystemMailArray } = useGetSystemMail();
    const { materialDocumentArray, isLoadingMaterialDocumentArray, refetchMaterialDocument } = useGetMaterialDocument();
    const { contractStateArray, isLoadingContractState, refetchContractState } = useGetContractState();
    const { contractTypeArray, isLoadingContractType, refetchContractType } = useGetContractType();
    const { reasonCancellationArray, isLoadingReasonCancellationArray, refetchReasonCancellationArray } =
        useGetReasonCancellation();

    const [editProject, setEditProject] = useState(getEmptyProject(getEmptyCustomer()));
    const [wasSuccessfully, setWasSuccessfully] = useState(true);
    const [isLoadgin, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenConfirmClose, setIsOpenConfirmClose] = useState(false);
    const [feedback, setFeedback] = useState<IFeedback>({
        open: false,
        message: "Gespeichert!",
        severity: "success",
    } as IFeedback);
    const [isOpenNewProject, setIsOpenNewProject] = useState(false);
    const [newCustomer, setNewCustomer] = useState<ICustomer | null>(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
    const [projectIdToDelete, setProjectIdToDelete] = React.useState<number | null>(null);

    const isSuperuser = localStorage.getItem("is_superuser") === "true";
    const idRole = localStorage.getItem("idRole");
    const canDelete = idRole === "1" || idRole === "2" || isSuperuser;

    //-------------------------- EXPORT NEBENAKTE --------------------------
    const [openExportDialog, setOpenExportDialog] = useState<boolean>(false);
    const [includeDocuments, setIncludeDocuments] = useState<boolean>(false);
    const [isExporting, setIsExporting] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (params.id) {
            handleChangeId(params.id);
        }
    }, [params.id]);

    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: "Nr.",
            width: 90,
        },
        {
            field: "ProjectState",
            headerName: "Status",
            renderCell: (params: GridRenderCellParams<any, number>) => (
                <>{handleProjectState(Number(params.value), projectStateArray)}</>
            ),
            width: 150,
        },
        {
            field: "project_start",
            headerName: "Projektstart",
            renderCell: (params: GridRenderCellParams<any, Date>) =>
                params.value === null ? <></> : <>{new Date(String(params.value)).toLocaleDateString()}</>,
            width: 150,
        },
        {
            field: "Participant",
            headerName: "Kunde",
            renderCell: (params: GridRenderCellParams<any, IProjectParticipant[]>) => {
                let testCustomer = customerArray?.find(
                    (x) => x.id === params.value?.find((y) => y.is_contact_person)?.Customer,
                );

                if (testCustomer === undefined) {
                    return <i>Konnte Kunde nicht bestimmen</i>;
                } else {
                    return (
                        <>
                            {testCustomer.b2b && `${testCustomer.Company?.company_name}:`}{" "}
                            {`${testCustomer.firstname} ${testCustomer.lastname}`}
                        </>
                    );
                }
            },
            width: 250,
        },
        {
            field: "title",
            headerName: "Titel",
            flex: 1,
        },
        {
            field: "action",
            headerName: "Aktionen",
            renderCell: (params: GridRenderCellParams<any, number>) => {
                return (
                    <>
                        {" "}
                        {canDelete && (
                            <>
                                <IconButton
                                    style={{ position: "relative" }}
                                    size="small"
                                    onClick={() => openDeleteConfirmationDialog(params.row.id)}
                                >
                                    <Delete />
                                </IconButton>
                                <Dialog
                                    open={openDeleteDialog && projectIdToDelete === params.row.id}
                                    onClose={closeDeleteConfirmationDialog}
                                >
                                    <DialogTitle>Bestätigung Löschung</DialogTitle>
                                    <DialogContent>
                                        Sind Sie sicher, dass Sie "{params.row["title"]}" löschen wollen?
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={closeDeleteConfirmationDialog} color="primary">
                                            Abbruch
                                        </Button>
                                        <Button onClick={() => handleRemove(params.row.id)} color="primary">
                                            Bestätigen
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </>
                        )}
                    </>
                );
            },
            width: 100,
        },
    ];

    const openDeleteConfirmationDialog = (projectId: number) => {
        setProjectIdToDelete(projectId);
        setOpenDeleteDialog(true);
    };
    const closeDeleteConfirmationDialog = () => {
        setProjectIdToDelete(null);
        setOpenDeleteDialog(false);
    };
    const handleRemove = (projectId: number) => {
        if (canDelete) {
            deleteFetch("/project/", projectId, setWasSuccessfully);
            setFeedback({ open: true, message: "Projekt erfolgreich gelöscht!", severity: "success" });
            refetchProjectSmall();
            /*
            const newArray =
                projectArray === undefined ? "" : projectArray.filter((project) => project.id !== projectId);
            setProjectArray(newArray);
            */
            closeDeleteConfirmationDialog();
        } else {
        }
    };
    const handleChangeId = async (id: string | number) => {
        let returnObject = await getProjectById(Number(id));
        setEditProject(returnObject);
        setIsOpen(true);
    };
    const handleNew = () => {
        setEditProject(getEmptyProject(getEmptyCustomer()));
        setNewCustomer(null);
        setIsOpenNewProject(true);
    };
    const handleAfterSave = (savedObject: IProject) => {
        /*
        if (projectArray !== undefined) {
            setFeedback({ open: true, message: "Gespeichert!", severity: "success" });

            let testObject = projectArray.find((x) => x.id === savedObject.id);

            if (testObject === undefined) {
                setProjectArray([...projectArray, savedObject]);
            } else {
                setProjectArray([...projectArray.map((x) => (x.id === savedObject.id ? savedObject : x))]);
            }

            navigate("/projects");
            setIsOpen(false);
        }
        */
        refetchProjectSmall();
        navigate("/projects");
        setIsOpen(false);
    };
    const handleSave = async () => {
        let orgProject = projectSmallArray?.find((proj) => proj.id === editProject.id);
        try {
            let triggerAutomationObj: IAutomationTrigger = {
                AutomationCategory: 1,
                payload_id: editProject.id,
                target_state: editProject.ProjectState,
                current_state: Number(orgProject?.ProjectState),
            };

            let allOfferPositions = editProject.Offers.flatMap((offer) => offer.OfferPositions);

            let updatedOfferPositions = await updateOfferPositions(allOfferPositions);

            let updatedProject = await updateProject(editProject);

            setFeedback({ open: true, message: "Erfolgreich gespeichert!", severity: "success" });
            if (Number(orgProject?.ProjectState) < editProject.ProjectState) {
                let returnObject = await triggerAutomation(triggerAutomationObj);
                let systemMails: IAutomationMailWorkerEdit[] = [];
                returnObject.AutomationMailArray.map((autoMail) => {
                    systemMails.push({
                        ...autoMail,
                        payload_id: editProject.id,
                        is_send: true,
                    });
                });
                setAutomationMailWorkerEditArray(systemMails);
            }

            let finalProject: IProject = {
                ...updatedProject,
                Offers: editProject.Offers.map((offer: IOffer) => ({
                    ...offer,
                    OfferPositions: updatedOfferPositions.filter((op: IOfferPosition) => op.Offer === offer.id),
                })),
            };

            handleAfterSave(finalProject);
        } catch (error) {
            console.error(error);
            setFeedback({ open: true, message: "Es ist ein Fehler aufgeretten!", severity: "error" });
        }
    };
    const handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setWasSuccessfully(true);
        handleSave();
    };
    const handleAfterSaveNew = (newProject: IProject) => {
        if (projectSmallArray !== undefined) {
            refetchProjectSmall();
            //setProjectArray([newProject, ...projectArray]);
            setEditProject(newProject);
            setIsOpenNewProject(false);
        }
    };
    const handleAfterCustomerSave = (newCustomer: ICustomer) => {
        if (customerArray !== undefined) {
            setCustomerArray([...customerArray, newCustomer]);

            let uploadObject = { ...editProject, MainCustomer: newCustomer.id };

            uploadFetch(
                "/project/",
                true,
                uploadObject,
                handleAfterSaveNew,
                setWasSuccessfully,
                () => {},
                setIsLoading,
            );
        }
    };
    const handleSubmitNew = (e: React.SyntheticEvent) => {
        e.preventDefault();

        if (newCustomer === null) {
            uploadFetch("/project/", true, editProject, handleAfterSaveNew, setWasSuccessfully, () => {}, setIsLoading);
        } else {
            let uploadObject = {
                ...newCustomer,
                Address: newCustomer.b2b ? undefined : newCustomer.Address,
                Company: newCustomer.b2b ? newCustomer.Company : undefined,
            } as ICustomer;
            uploadFetch(
                "/customer/",
                true,
                uploadObject,
                handleAfterCustomerSave,
                setWasSuccessfully,
                () => {},
                setIsLoading,
            );
        }
    };
    const handleSearchTerm = () => {
        if (projectSmallArray === undefined) {
            return [];
        } else if (searchTerm === "") {
            return projectSmallArray.filter((x) => (filteredState === 0 ? true : x.ProjectState === filteredState));
        } else {
            return projectSmallArray
                .filter((x) => (filteredState === 0 ? true : x.ProjectState === filteredState))
                .filter(
                    (x) =>
                        String(x.title).toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()) ||
                        x.Participant.map((y) => customerArray?.find((z) => z.id === y.Customer)).find(
                            (y) =>
                                y?.firstname.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()) ||
                                y?.lastname.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
                        ),
                );
        }
    };

    const handleCloseEditor = () => {
        navigate("/projects");
        setIsOpenConfirmClose(false);
        setIsOpenNewProject(false);
        setIsOpen(false);
    };

    useEffect(() => {
        if (!wasSuccessfully) {
            setFeedback({ open: true, message: "Ein fehler ist aufgetretten!", severity: "error" });
            setIsLoading(false);
        }
    }, [wasSuccessfully]);
    useEffect(() => {
        if (params.id) {
            handleChangeId(params.id);
        }
    }, [params.id]);

    //Export PDF
    const handleExportClick = async () => {
        let hadError = false;
        try {
            setError("");
            setIsExporting(true);
            const endpoint = `/project/${editProject.id}/export-projectPDF/?includeDocuments=true`;

            const blob = await customFetcher({
                endpoint,
                method: "GET",
                responseType: "blob",
            });

            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = `Projekt_${editProject.id}_Akte.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (err) {
            console.error("Fehler beim Export:", err);
            setError("Der Export ist fehlgeschlagen. Bitte wenden Sie sich an Ihren Administrator");
            hadError = true;
        } finally {
            setIsExporting(false);
            if (!hadError) {
                setOpenExportDialog(false);
            }
        }
    };

    const handleCloseExport = () => {
        if (!isExporting) {
            setError("");
            setOpenExportDialog(false);
        }
    };

    if (
        (isLoadingProjectSmallArray === false && projectSmallArray === undefined) ||
        (isLoadingProjectStateArray === false && projectStateArray === undefined) ||
        (statusCodeAcademicTitle !== null && statusCodeAcademicTitle !== 200) ||
        (statusCodeAddressType !== null && statusCodeAddressType !== 200) ||
        (statusCodeGender !== null && statusCodeGender !== 200) ||
        (statusCodeCustomer !== null && statusCodeCustomer !== 200) ||
        (statusCodeUser !== null && statusCodeUser !== 200) ||
        (statusCodeInsurance !== null && statusCodeInsurance !== 200) ||
        (isLoadingPartnerArray === false && partnerArray === undefined) ||
        (statusCodePropertyManagement !== null && statusCodePropertyManagement !== 200) ||
        (isLoadingUnits === false && units === undefined) ||
        (isLoadingServices === false && serviceArray === undefined) ||
        (isLoadingServiceCategories === false && serviceCategoryArray === undefined) ||
        (statusCodeTemplate !== null && statusCodeTemplate !== 200) ||
        (statusCodeMaterial !== null && statusCodeMaterial !== 200) ||
        (statusCodeMaterialCategory !== null && statusCodeMaterialCategory !== 200) ||
        (statusCodeMaterialSubcategory !== null && statusCodeMaterialSubcategory !== 200) ||
        (statusCodeOfferState !== null && statusCodeOfferState !== 200) ||
        (statusCodeOfferType !== null && statusCodeOfferType !== 200) ||
        (statusCodeMimeType !== null && statusCodeMimeType !== 200) ||
        (statusCodeBillStateArray !== null && statusCodeBillStateArray !== 200) ||
        (isLoadingReasonCancellationArray === false && reasonCancellationArray === undefined) ||
        (isLoadingSystemMailArray === false && systemMailArray === undefined) ||
        (isLoadingAutomationArray === false && automationArary === undefined) ||
        (isLoadingInvoiceStates === false && invoiceStates === undefined) ||
        (isLoadingInvoiceTypes === false && invoiceTypes === undefined)
    ) {
        return <Alert severity="error">Fehler!</Alert>;
    } else if (
        !projectSmallArray ||
        !projectStateArray ||
        genderData === undefined ||
        titleData === undefined ||
        addressTypeArray === undefined ||
        customerArray === undefined ||
        userArray === undefined ||
        insuranceArray === undefined ||
        !partnerArray ||
        propertyManagementArray === undefined ||
        !units ||
        !serviceArray ||
        !serviceCategoryArray ||
        templateArray === undefined ||
        materialArray === undefined ||
        materialCategoryArray === undefined ||
        materialSubcategoryArray === undefined ||
        offerStateArray === undefined ||
        offerTypeArray === undefined ||
        mimeTypeArray === undefined ||
        billStateArray === undefined ||
        !systemMailArray ||
        !reasonCancellationArray ||
        !automationArary ||
        !invoiceStates ||
        !invoiceTypes
    ) {
        return <LinearProgress />;
    } else {
        return (
            <>
                {isPendingProjectById && (
                    <Dialog open>
                        <DialogContent>Das Projekt wird geladen...</DialogContent>
                    </Dialog>
                )}

                <AutomationMailWorkerEditDialog
                    automationMailWorkerEditArray={automationMailWorkerEditArray}
                    setAutomationMailWorkerEditArray={setAutomationMailWorkerEditArray}
                    setFeedback={setFeedback}
                />

                <Dialog open={isOpenConfirmClose} onClose={() => setIsOpenConfirmClose(false)}>
                    <DialogTitle>Projekt schließen</DialogTitle>
                    <DialogContent>
                        Sind Sie sicher, dass Sie das aktuelle Projekt schließen wollen?
                        <br />
                        Ungespeicherte Änderungen gehen verloren.
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenConfirmClose(false)}>
                            Abbruch
                        </Button>
                        <Button variant="contained" onClick={handleCloseEditor}>
                            Schließen ohne zu speichern
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={isOpenNewProject} onClose={() => setIsOpenConfirmClose(true)} maxWidth="md" fullWidth>
                    <DialogTitle>Neues Projekt</DialogTitle>
                    <DialogContent>
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid item sm={12}>
                                    <CustomeTextField
                                        label="Titel"
                                        attr="title"
                                        type="string"
                                        object={editProject}
                                        setObject={setEditProject}
                                        required
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{ float: "right" }} onClick={() => setIsOpenNewProject(false)} variant="outlined">
                            Abbruch
                        </Button>
                        <Button
                            sx={{ float: "right", ml: 2 }}
                            onClick={handleSubmitNew}
                            variant="contained"
                            disabled={isLoadgin}
                        >
                            Speichern
                        </Button>
                    </DialogActions>
                </Dialog>

                {isPendingTriggerAutomation && (
                    <Dialog open>
                        <DialogContent>
                            Lade Automatisierungen...
                            <CircularProgress />
                        </DialogContent>
                    </Dialog>
                )}

                <Dialog open={openExportDialog} onClose={handleCloseExport} maxWidth="xs" fullWidth>
                    <DialogTitle>Projektakte exportieren</DialogTitle>
                    <DialogContent>
                        {isExporting && <LinearProgress sx={{ mb: 2 }} />}
                        {error && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {error}
                            </Alert>
                        )}
                        <Typography>
                            Hier können Sie das gesamte Projekt, inkl. Angebote, Verträge etc. exportieren. Je nach
                            Projektumfang kann dies bis zu einer Minute dauern.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseExport} disabled={isExporting}>
                            Abbrechen
                        </Button>
                        <Button variant="contained" onClick={handleExportClick} disabled={isExporting}>
                            {isExporting ? "Lädt..." : "Projektakte herunterladen"}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={isOpen} onClose={() => setIsOpenConfirmClose(true)} maxWidth="lg" fullWidth>
                    <form onSubmit={handleSubmit}>
                        <DialogTitle>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Typography variant="h6">Projekte</Typography>
                                <Button variant="outlined" onClick={() => setOpenExportDialog(true)} sx={{ mb: 2 }}>
                                    Projektakte exportieren
                                </Button>
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            <>
                                <ProjectEdit
                                    key={`project-${editProject.id}`}
                                    projectObject={editProject}
                                    setProjectObject={setEditProject}
                                    projectStateArray={projectStateArray}
                                    reasonCancellationArray={reasonCancellationArray}
                                    genderArray={genderData}
                                    academicTitleArray={titleData}
                                    addressTypeArray={addressTypeArray}
                                    customerArray={customerArray}
                                    setCustomerArray={setCustomerArray}
                                    userArray={userArray}
                                    insuranceArray={insuranceArray}
                                    setInsuranceArray={setInsuranceCodeData}
                                    propertyManagementArray={propertyManagementArray}
                                    setPropertyManagementArray={setPropertyManagementArray}
                                    unitArray={units}
                                    serviceArray={serviceArray}
                                    templateArray={templateArray}
                                    serviceCategoryArray={serviceCategoryArray}
                                    materialArray={materialArray}
                                    materialCategoryArray={materialCategoryArray}
                                    materialSubcategoryArray={materialSubcategoryArray}
                                    offerStateArray={offerStateArray}
                                    offerTypeArray={offerTypeArray}
                                    partnerArray={partnerArray}
                                    mimeTypeArray={mimeTypeArray}
                                    materialDocumentArray={materialDocumentArray}
                                    billStateArray={billStateArray}
                                    systemMailArray={systemMailArray}
                                    contractStateArray={contractStateArray || []}
                                    contractTypeArray={contractTypeArray || []}
                                    invoiceStates={invoiceStates}
                                    invoiceTypes={invoiceTypes}
                                />
                            </>
                        </DialogContent>
                        <DialogActions
                            style={{
                                position: "sticky",
                                bottom: 0,
                                background: "white",
                                zIndex: 1000,
                                padding: 8,
                            }}
                        >
                            <Button
                                disabled={isPending}
                                sx={{ float: "right" }}
                                onClick={handleCloseEditor}
                                variant="outlined"
                            >
                                Abbruch
                            </Button>
                            <Button variant="contained" disabled={isPending} type="submit">
                                {isPending ? (
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <span>Speichern</span>
                                        <CircularProgress size={20} />
                                    </Box>
                                ) : (
                                    "Speichern"
                                )}
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>

                <Typography variant="h5">
                    Projekte
                    {true && (
                        <Button sx={{ float: "right" }} variant="outlined" onClick={handleNew}>
                            Neues Projekt
                        </Button>
                    )}
                </Typography>

                <Collapse sx={{ mt: 1 }} in={isLoadgin}>
                    <LinearProgress />
                </Collapse>

                <CustomSnackbar feedback={feedback} setFeedback={setFeedback} />

                <Grid container spacing={2}>
                    <Grid item sm={3}>
                        <TextField
                            variant="outlined"
                            label="Status"
                            fullWidth
                            value={filteredState}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                setFilteredState(Number(event.target.value))
                            }
                            select
                        >
                            <MenuItem key="servicecategorie-all" value={0}>
                                Alle
                            </MenuItem>
                            {projectStateArray.map((state) => (
                                <MenuItem key={`state-${state.id}`} value={state.id}>
                                    {state.projectState}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={9}>
                        <TextField
                            label="Suche"
                            fullWidth
                            value={searchTerm}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(event.target.value)}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item sm={12}>
                        <DataGrid
                            localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                            rows={handleSearchTerm()}
                            columns={columns}
                            onRowClick={(params, event, details) => {
                                if (true) {
                                    const target = event.target as HTMLElement;
                                    const isDeleteIconClicked = target.closest(".MuiIconButton-root") !== null;
                                    if (isDeleteIconClicked) {
                                        event.stopPropagation();
                                        openDeleteConfirmationDialog(Number(params.id));
                                    } else {
                                        //handleChangeId(params);
                                        navigate(`/projects/${params.id}`);
                                    }
                                }
                            }}
                            autoHeight
                        />
                    </Grid>
                </Grid>
            </>
        );
    }
};
